export default __webpack_public_path__ + "static/media/doc-edit.d0ef98c6.svg";